import React from "react";
import styles from "./footer.module.css";
const Footer = () => {
  return (
    <div className={styles.container}>
      <h3 className={styles.text}>© Design and Developed by Adithyan K P</h3>
    </div>
  );
};

export default Footer;
